<svg width="0" height="0" style="position: absolute;">
  <defs>
    <clipPath id="shape-mask" clipPathUnits="objectBoundingBox">
      <path d="M0.077,0 H0.923 C0.965,0 1,0.035 1,0.077 V0.78 C1,0.822 0.965,0.857 0.923,0.857 H0.78 C0.738,0.857 0.703,0.892 0.703,0.934 V0.923 C0.703,0.965 0.668,1 0.626,1 H0.077 C0.035,1 0,0.965 0,0.923 V0.077 C0,0.035 0.035,0 0.077,0 Z" />
    </clipPath>
  </defs>
</svg>

@if (isLoading) {
  <div class="flex items-center justify-center min-h-screen min-w-screen bg-foreground-base">
    <l-spinner />
  </div>
  
} @else {
  <main
    class="flex items-center justify-between px-4 min-h-screen bg-gradient-to-r from-lBlack to-lBlue700"
  >
    <section
      class="flex flex-col items-center justify-center w-full lg:max-w-[40%]"
    >
      <img class="mx-auto mb-5" [src]="tenantData?.logoUrl || 'assets/images/unico-logo.svg'" alt="Logo" width="130" />

      <div class="space-y-2 text-center">
        <h1 class="text-lWhite text-2xl font-semibold">Acesse sua conta</h1>
        <p class="text-lSecondary text-sm">
          Acesse sua conta e explore um mundo de possibilidades
        </p>
      </div>

      @if (hasSSO) {
        <div
          class="w-full mx-auto mt-8 space-y-6 text-center animate-fadeIn lg:max-w-[30rem]"
        >
          <div class="space-y-4 pt-6">
            <button
              (click)="goToLogin()"
              [disabled]="isLoadingLogin"
              type="button"
              lButton
              [bType]="buttonTypes.PRIMARY"
              [bRadius]="buttonRadius.LARGE"
            >
              @if (!isLoadingLogin) {
                <span>Acessar tela de login</span>
              } @else {
                <div class="flex items-center gap-2">
                  <l-icon class="text-lg text-white animate-spin"
                    >progress_activity</l-icon
                  >
                </div>
              }
            </button>

            <button
              [disabled]="isLoadingLogin"
              type="button"
              lButton
              [bType]="buttonTypes.BASIC"
              [bRadius]="buttonRadius.LARGE"
              outline
            >
              Acessar administrador
            </button>
          </div>
        </div>
      } @else {
        <form
          [formGroup]="formGroup"
          (submit)="login()"
          autocomplete="off"
          class="w-full mx-auto mt-8 animate-fadeIn lg:max-w-[30rem]"
        >
          <div class="space-y-6">
            <div class="space-y-2">
                <label class="text-lSecondary text-sm font-medium" for="username"
                >E-mail</label
              >
              <div class="relative form-input">
                <l-icon class="form-input--icon">alternate_email</l-icon>
                <input
                  type="email"
                  id="username"
                  placeholder="exemplo@email.com"
                  formControlName="username"
                  autocomplete="off"
                />
              </div>
            </div>

            <div class="space-y-2">
              <label
                class="text-lSecondary text-sm font-medium"
                for="password"
                >Senha</label
              >
              <div class="relative flex items-center form-input">
                <l-icon class="form-input--icon">lock</l-icon>
                <input
                  [type]="isHiddenPassword ? 'password' : 'text'"
                  id="password"
                  placeholder="Digite sua senha"
                  formControlName="password"
                  autocomplete="off"
                />
                <button
                  type="button"
                  (click)="isHiddenPassword = !isHiddenPassword"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-lSecondary transition-colors hover:text-lWhite"
                >
                  <l-icon class="mt-2 text-base font-normal">
                    {{ isHiddenPassword ? "visibility_off" : "visibility" }}
                  </l-icon>
                </button>
              </div>
              <div class="flex justify-end">
                <a
                  routerLink="/forgot/password"
                  class="text-sm text-lSecondary transition-colors hover:text-lWhite"
                >
                  Esqueci minha senha
                </a>
              </div>
            </div>

            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="remember"
                  formControlName="keepLoggedIn"
                  class="custom-checkbox"
                />
                <label
                  for="remember"
                  class="text-lSecondary text-sm cursor-pointer transition-colors hover:text-lWhite"
                >
                  Lembre-se de mim
                </label>
              </div>
            </div>

            <button
              lButton
              [disabled]="isDisabled"
              type="submit"
              [bType]="isDisabled ? buttonTypes.OUTLINE : buttonTypes.PRIMARY"
              [bRadius]="buttonRadius.LARGE"
            >
              @if (isLoadingLogin) {
                <l-spinner
                  [size]="spinnerSize.SMALL"
                  [color]="spinnerColors.WHITE"
                />
              }

              <span>Entrar</span>
            </button>
          </div>
        </form>
      }
    </section>

    <aside class="hidden lg:flex flex-1 h-screen items-center justify-center">
      <div class="relative w-[95%] h-[95%]">
        <div class="w-full h-full shape-card"></div>

        <l-animated-banner
          class="absolute inset-0 z-10 pointer-events-none"
        />

        <div class="gradient-border absolute bottom-[20%] lg:bottom-[25%] xl:bottom-[30%] left-[5%] lg:left-[10%] z-20">
          <span class="text-lWhite text-sm lg:text-base xl:text-lg 2xl:text-xl font-semibold">Educação Corporativa</span>
        </div>
        <div class="gradient-border absolute bottom-[10%] lg:bottom-[15%] xl:bottom-[20%] left-0 z-20">
          <span class="text-lWhite text-sm lg:text-base xl:text-lg 2xl:text-xl font-semibold">
            Treinamentos e workshops
          </span>
        </div>

        <img src="assets/images/unico-logo.svg" alt="Unico Logo" class="absolute bottom-[5%] right-[7%] z-10 min-w-28 w-[15%]" />
      </div>
    </aside>
</main>
}
